export { matchers } from './client-matchers.js';

export const nodes = [() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120'),
	() => import('./nodes/121'),
	() => import('./nodes/122'),
	() => import('./nodes/123'),
	() => import('./nodes/124'),
	() => import('./nodes/125'),
	() => import('./nodes/126'),
	() => import('./nodes/127'),
	() => import('./nodes/128'),
	() => import('./nodes/129'),
	() => import('./nodes/130'),
	() => import('./nodes/131'),
	() => import('./nodes/132'),
	() => import('./nodes/133'),
	() => import('./nodes/134'),
	() => import('./nodes/135'),
	() => import('./nodes/136'),
	() => import('./nodes/137'),
	() => import('./nodes/138'),
	() => import('./nodes/139'),
	() => import('./nodes/140'),
	() => import('./nodes/141'),
	() => import('./nodes/142'),
	() => import('./nodes/143'),
	() => import('./nodes/144'),
	() => import('./nodes/145'),
	() => import('./nodes/146'),
	() => import('./nodes/147'),
	() => import('./nodes/148'),
	() => import('./nodes/149'),
	() => import('./nodes/150'),
	() => import('./nodes/151'),
	() => import('./nodes/152'),
	() => import('./nodes/153'),
	() => import('./nodes/154'),
	() => import('./nodes/155'),
	() => import('./nodes/156'),
	() => import('./nodes/157'),
	() => import('./nodes/158'),
	() => import('./nodes/159'),
	() => import('./nodes/160'),
	() => import('./nodes/161'),
	() => import('./nodes/162'),
	() => import('./nodes/163'),
	() => import('./nodes/164'),
	() => import('./nodes/165'),
	() => import('./nodes/166'),
	() => import('./nodes/167'),
	() => import('./nodes/168'),
	() => import('./nodes/169'),
	() => import('./nodes/170'),
	() => import('./nodes/171'),
	() => import('./nodes/172'),
	() => import('./nodes/173'),
	() => import('./nodes/174'),
	() => import('./nodes/175'),
	() => import('./nodes/176'),
	() => import('./nodes/177'),
	() => import('./nodes/178'),
	() => import('./nodes/179'),
	() => import('./nodes/180')];

export const server_loads = [];

export const dictionary = {
	"/": [43],
	"/forgot-password": [44],
	"/login": [45],
	"/login/first": [46],
	"/organizations": [165,[35]],
	"/organizations/add": [173,[35]],
	"/organizations/(setup)/analytics": [166,[35,36,37]],
	"/organizations/(setup)/billing": [167,[35,36,38]],
	"/organizations/(setup)/sensor-types": [168,[35,36,39]],
	"/organizations/(setup)/sensor-types/[sensorTypeId]": [169,[35,36,39]],
	"/organizations/(setup)/setup": [170,[35,36]],
	"/organizations/(setup)/users": [171,[35,36,40]],
	"/organizations/(setup)/users/[userId]": [172,[35,36,40]],
	"/org/[orgId]/(setup)/archived-projects": [47,[2,3,4]],
	"/org/[orgId]/(setup)/archived-projects/[projectId]": [48,[2,3,4]],
	"/org/[orgId]/(setup)/billing": [49,[2,3,5]],
	"/org/[orgId]/(setup)/billing/[projectId]": [50,[2,3,5]],
	"/org/[orgId]/(setup)/organization": [51,[2,3]],
	"/org/[orgId]/profile": [58,[2]],
	"/org/[orgId]/projects": [163,[2]],
	"/org/[orgId]/projects/add": [164,[2]],
	"/org/[orgId]/proj/[projId]/(setup)/alarm-subscriptions": [59,[8,9]],
	"/org/[orgId]/proj/[projId]/alarms": [148,[8]],
	"/org/[orgId]/proj/[projId]/(setup)/blueprints": [60,[8,9,10]],
	"/org/[orgId]/proj/[projId]/(setup)/blueprints/add": [72,[8,9,10]],
	"/org/[orgId]/proj/[projId]/(setup)/blueprints/duplicate": [73,[8,9,10]],
	"/org/[orgId]/proj/[projId]/(setup)/blueprints/[sensorModelId]": [61,[8,9,10,11]],
	"/org/[orgId]/proj/[projId]/(setup)/blueprints/[sensorModelId]/charts": [62,[8,9,10,11]],
	"/org/[orgId]/proj/[projId]/(setup)/blueprints/[sensorModelId]/charts/timeseries/add": [64,[8,9,10,11]],
	"/org/[orgId]/proj/[projId]/(setup)/blueprints/[sensorModelId]/charts/timeseries/[chartId]": [63,[8,9,10,11]],
	"/org/[orgId]/proj/[projId]/(setup)/blueprints/[sensorModelId]/charts/wind-rose/add": [66,[8,9,10,11]],
	"/org/[orgId]/proj/[projId]/(setup)/blueprints/[sensorModelId]/charts/wind-rose/[windRoseChartId]": [65,[8,9,10,11]],
	"/org/[orgId]/proj/[projId]/(setup)/blueprints/[sensorModelId]/charts/xy/add": [68,[8,9,10,11]],
	"/org/[orgId]/proj/[projId]/(setup)/blueprints/[sensorModelId]/charts/xy/[xyChartId]": [67,[8,9,10,11]],
	"/org/[orgId]/proj/[projId]/(setup)/blueprints/[sensorModelId]/dashboard": [69,[8,9,10,11]],
	"/org/[orgId]/proj/[projId]/(setup)/blueprints/[sensorModelId]/fields": [70,[8,9,10,11]],
	"/org/[orgId]/proj/[projId]/(setup)/blueprints/[sensorModelId]/formulas": [71,[8,9,10,11]],
	"/org/[orgId]/proj/[projId]/charts/custom": [149,[8,28,29]],
	"/org/[orgId]/proj/[projId]/charts/custom/[customChartId]": [150,[8,28,29]],
	"/org/[orgId]/proj/[projId]/charts/sensors": [151,[8,28]],
	"/org/[orgId]/proj/[projId]/(setup)/custom-charts": [74,[8,9]],
	"/org/[orgId]/proj/[projId]/(setup)/custom-charts/add": [76,[8,9]],
	"/org/[orgId]/proj/[projId]/(setup)/custom-charts/[customChartId]": [75,[8,9]],
	"/org/[orgId]/proj/[projId]/(setup)/custom-dashboards": [77,[8,9,12]],
	"/org/[orgId]/proj/[projId]/(setup)/custom-dashboards/add": [79,[8,9,12]],
	"/org/[orgId]/proj/[projId]/(setup)/custom-dashboards/[customDashboardId]": [78,[8,9,12]],
	"/org/[orgId]/proj/[projId]/dashboards/custom": [152,[8,30,31]],
	"/org/[orgId]/proj/[projId]/dashboards/custom/[customDashboardId]": [153,[8,30,31]],
	"/org/[orgId]/proj/[projId]/dashboards/sensors": [154,[8,30]],
	"/org/[orgId]/proj/[projId]/(setup)/data-connections": [80,[8,9,13]],
	"/org/[orgId]/proj/[projId]/(setup)/data-connections/ftps/add": [82,[8,9,13]],
	"/org/[orgId]/proj/[projId]/(setup)/data-connections/ftps/[ftpId]": [81,[8,9,13]],
	"/org/[orgId]/proj/[projId]/(setup)/data-connections/omnidots-honeycomb-api-tokens/add": [84,[8,9,13]],
	"/org/[orgId]/proj/[projId]/(setup)/data-connections/omnidots-honeycomb-api-tokens/[omnidotsHoneycombAPITokenId]": [83,[8,9,13]],
	"/org/[orgId]/proj/[projId]/(setup)/data-connections/worldsensing-mqtt-brokers/add": [86,[8,9,13]],
	"/org/[orgId]/proj/[projId]/(setup)/data-connections/worldsensing-mqtt-brokers/[worldsensingMQTTBrokerId]": [85,[8,9,13]],
	"/org/[orgId]/proj/[projId]/(setup)/data-connections/worldsensing-user-tokens/add": [88,[8,9,13]],
	"/org/[orgId]/proj/[projId]/(setup)/data-connections/worldsensing-user-tokens/[worldsensingUserTokenId]": [87,[8,9,13]],
	"/org/[orgId]/proj/[projId]/(setup)/data-sources": [89,[8,9,14]],
	"/org/[orgId]/proj/[projId]/(setup)/data-sources/data-file-parsers/add": [95,[8,9,14]],
	"/org/[orgId]/proj/[projId]/(setup)/data-sources/data-file-parsers/[parserId]": [90,[8,9,14,15]],
	"/org/[orgId]/proj/[projId]/(setup)/data-sources/data-file-parsers/[parserId]/file-mapping": [91,[8,9,14,15]],
	"/org/[orgId]/proj/[projId]/(setup)/data-sources/data-file-parsers/[parserId]/logs": [92,[8,9,14,15]],
	"/org/[orgId]/proj/[projId]/(setup)/data-sources/data-file-parsers/[parserId]/logs/[logId]": [93,[8,9,14,15]],
	"/org/[orgId]/proj/[projId]/(setup)/data-sources/data-file-parsers/[parserId]/sensor-mapping": [94,[8,9,14,15]],
	"/org/[orgId]/proj/[projId]/(setup)/data-sources/image-data-sources/add": [100,[8,9,14]],
	"/org/[orgId]/proj/[projId]/(setup)/data-sources/image-data-sources/[imageDataSourceId]": [96,[8,9,14,16]],
	"/org/[orgId]/proj/[projId]/(setup)/data-sources/image-data-sources/[imageDataSourceId]/logs": [97,[8,9,14,16]],
	"/org/[orgId]/proj/[projId]/(setup)/data-sources/image-data-sources/[imageDataSourceId]/logs/[logId]": [98,[8,9,14,16]],
	"/org/[orgId]/proj/[projId]/(setup)/data-sources/image-data-sources/[imageDataSourceId]/sensor-mapping": [99,[8,9,14,16]],
	"/org/[orgId]/proj/[projId]/(setup)/data-sources/omnidots/add": [103,[8,9,14]],
	"/org/[orgId]/proj/[projId]/(setup)/data-sources/omnidots/[omnidotsDataSourceId]": [101,[8,9,14,17]],
	"/org/[orgId]/proj/[projId]/(setup)/data-sources/omnidots/[omnidotsDataSourceId]/sensor-mapping": [102,[8,9,14,17]],
	"/org/[orgId]/proj/[projId]/(setup)/data-sources/senceive/add": [106,[8,9,14]],
	"/org/[orgId]/proj/[projId]/(setup)/data-sources/senceive/[senceiveId]": [104,[8,9,14,18]],
	"/org/[orgId]/proj/[projId]/(setup)/data-sources/senceive/[senceiveId]/sensor-mapping": [105,[8,9,14,18]],
	"/org/[orgId]/proj/[projId]/(setup)/data-sources/worldsensing-nodes/add": [109,[8,9,14]],
	"/org/[orgId]/proj/[projId]/(setup)/data-sources/worldsensing-nodes/[worldsensingNodeId]": [107,[8,9,14,19]],
	"/org/[orgId]/proj/[projId]/(setup)/data-sources/worldsensing-nodes/[worldsensingNodeId]/sensor-mapping": [108,[8,9,14,19]],
	"/org/[orgId]/proj/[projId]/(setup)/data-sources/worldsensing-threads/add": [112,[8,9,14]],
	"/org/[orgId]/proj/[projId]/(setup)/data-sources/worldsensing-threads/[worldsensingThreadId]": [110,[8,9,14,20]],
	"/org/[orgId]/proj/[projId]/(setup)/data-sources/worldsensing-threads/[worldsensingThreadId]/sensor-mapping": [111,[8,9,14,20]],
	"/org/[orgId]/proj/[projId]/(setup)/manufacturers": [113,[8,9]],
	"/org/[orgId]/proj/[projId]/(setup)/manufacturers/add": [115,[8,9]],
	"/org/[orgId]/proj/[projId]/(setup)/manufacturers/[manufacturerId]": [114,[8,9]],
	"/org/[orgId]/proj/[projId]/(setup)/map-images": [116,[8,9]],
	"/org/[orgId]/proj/[projId]/(setup)/map-images/add": [119,[8,9]],
	"/org/[orgId]/proj/[projId]/(setup)/map-images/[sectionViewId]": [117,[8,9,21]],
	"/org/[orgId]/proj/[projId]/(setup)/map-images/[sectionViewId]/coordinates": [118,[8,9,21]],
	"/org/[orgId]/proj/[projId]/map": [155,[8,32]],
	"/org/[orgId]/proj/[projId]/map/[sectionViewId]": [156,[8,32]],
	"/org/[orgId]/proj/[projId]/(setup)/project": [120,[8,9,22]],
	"/org/[orgId]/proj/[projId]/(setup)/project/alarm-levels": [121,[8,9,22]],
	"/org/[orgId]/proj/[projId]/readings": [157,[8,33]],
	"/org/[orgId]/proj/[projId]/readings/[sensorId]": [158,[8,33]],
	"/org/[orgId]/proj/[projId]/(setup)/reports": [122,[8,9,23]],
	"/org/[orgId]/proj/[projId]/(setup)/reports/add": [129,[8,9,23]],
	"/org/[orgId]/proj/[projId]/(setup)/reports/[reportId]": [123,[8,9,23,24]],
	"/org/[orgId]/proj/[projId]/(setup)/reports/[reportId]/generated-reports": [125,[8,9,23,24]],
	"/org/[orgId]/proj/[projId]/(setup)/reports/[reportId]/generate": [124],
	"/org/[orgId]/proj/[projId]/(setup)/reports/[reportId]/layout": [126,[8,9,23,24]],
	"/org/[orgId]/proj/[projId]/(setup)/reports/[reportId]/preview": [127],
	"/org/[orgId]/proj/[projId]/(setup)/reports/[reportId]/view/[reportFilename]": [128],
	"/org/[orgId]/proj/[projId]/(setup)/sensor-types": [130,[8,9]],
	"/org/[orgId]/proj/[projId]/(setup)/sensor-types/add": [132,[8,9]],
	"/org/[orgId]/proj/[projId]/(setup)/sensor-types/[sensorTypeId]": [131,[8,9]],
	"/org/[orgId]/proj/[projId]/sensors-overview": [159,[8]],
	"/org/[orgId]/proj/[projId]/sensors-overview/[sensorId]": [160,[8,34]],
	"/org/[orgId]/proj/[projId]/sensors-overview/[sensorId]/alarms": [161,[8,34]],
	"/org/[orgId]/proj/[projId]/sensors-overview/[sensorId]/calibrations": [162,[8,34]],
	"/org/[orgId]/proj/[projId]/(setup)/sensors": [133,[8,9]],
	"/org/[orgId]/proj/[projId]/(setup)/sensors/add-profile": [142,[8,9]],
	"/org/[orgId]/proj/[projId]/(setup)/sensors/add": [141,[8,9]],
	"/org/[orgId]/proj/[projId]/(setup)/sensors/[sensorId]": [134,[8,9,25]],
	"/org/[orgId]/proj/[projId]/(setup)/sensors/[sensorId]/alarms": [135,[8,9,25]],
	"/org/[orgId]/proj/[projId]/(setup)/sensors/[sensorId]/calibrations": [136,[8,9,25]],
	"/org/[orgId]/proj/[projId]/(setup)/sensors/[sensorId]/images": [137,[8,9,25,26]],
	"/org/[orgId]/proj/[projId]/(setup)/sensors/[sensorId]/images/[sensorImageId]": [138,[8,9,25,26]],
	"/org/[orgId]/proj/[projId]/(setup)/sensors/[sensorId]/mapping": [139,[8,9,25]],
	"/org/[orgId]/proj/[projId]/(setup)/sensors/[sensorId]/overdue-alarms": [140,[8,9,25]],
	"/org/[orgId]/proj/[projId]/(setup)/users": [143,[8,9]],
	"/org/[orgId]/proj/[projId]/(setup)/users/add-to-project": [147,[8,9]],
	"/org/[orgId]/proj/[projId]/(setup)/users/add": [146,[8,9]],
	"/org/[orgId]/proj/[projId]/(setup)/users/[userId]": [144,[8,9,27]],
	"/org/[orgId]/proj/[projId]/(setup)/users/[userId]/alarm-subscriptions": [145,[8,9,27]],
	"/org/[orgId]/(setup)/sensor-types": [52,[2,3,6]],
	"/org/[orgId]/(setup)/sensor-types/[sensorTypeId]": [53,[2,3,6]],
	"/org/[orgId]/(setup)/users": [54,[2,3,7]],
	"/org/[orgId]/(setup)/users/add-to-organization": [57,[2,3,7]],
	"/org/[orgId]/(setup)/users/add": [56,[2,3,7]],
	"/org/[orgId]/(setup)/users/[userId]": [55,[2,3,7]],
	"/playground": [174,[41]],
	"/playground/charts": [175,[41]],
	"/playground/components": [176,[41]],
	"/playground/icons": [177,[41]],
	"/playground/sentry": [178,[41]],
	"/profile": [179,[42]],
	"/reset-password": [180]
};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
};